module.exports = __webpack_public_path__ + "img/软件服务规划咨询.e552d761.png";